var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';
import Button from '../../components/Button';
import Input from '../../components/Input';

/**
 * @component Subscriptions
 * @description Manage subscriptions
 */

var Subscriptions = function (_React$Component) {
  _inherits(Subscriptions, _React$Component);

  function Subscriptions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Subscriptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Subscriptions.__proto__ || Object.getPrototypeOf(Subscriptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoading: false,
      optInOut: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Subscriptions, [{
    key: 'componentDidMount',


    /**
     * @name componentDidMount
     * @lifecycle
     * @description Enable use of mockdata that is providied on intial load, if not provided on initial mount next
     * "componentWillReceiveProps" will be used.
     */
    value: function componentDidMount() {
      this.populateState(this.props);
    }

    /**
     * @name componentWillReceiveProps
     * @lifecycle
     * @description This will copy the opInOut prop to the local state. The reason why
     * we're not using componentWillMount in the constructor is because the props
     * will be empty intially, and then will be passed after a request.
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.populateState(nextProps);
    }
  }, {
    key: 'populateState',
    value: function populateState(props) {
      if (props.optInOut && props.optInOut.length) {
        this.setState({
          optInOut: props.optInOut
        });
      }
    }

    /**
     * @name onSumbit
     * @description Calls the 'onSubmit prop'. This is expected to be a function that returns
     * a promise. Therefore we can check when the call is done and set this.state.isLoading
     * to false afterwards. If this doesnt return a promise, you'll get a warning.
     */

  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var onSubmitProp = this.props.onSubmit({ optInOut: this.state.optInOut });
      this.setState({ isLoading: true });

      if (onSubmitProp.then) {
        onSubmitProp.then(function () {
          return _this2.setState({ isLoading: false });
        });
      } else {
        console.warn('onSubmit prop must return a promise!');
        this.setState({ isLoading: true });
      }
    }

    /**
     * @name onClickCheckbox
     * @param {*} e the event object
     * @description Setting the correct value in the component state.
     */

  }, {
    key: 'onClickCheckbox',
    value: function onClickCheckbox(_ref2) {
      var e = _ref2.e,
          option = _ref2.option;
      var checked = e.target.checked;
      var optInOut = this.state.optInOut;


      this.setState({
        optInOut: optInOut.map(function (o) {
          if (o.Type === option.Type) {
            return _extends({}, o, { OptIn: checked });
          } else {
            return o;
          }
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          optInOut = _state.optInOut,
          isLoading = _state.isLoading;
      var intl = this.props.intl;


      return React.createElement(
        'div',
        { className: 'Subscriptions' },
        optInOut.map(function (option, index) {
          return React.createElement(
            'div',
            { key: index, className: 'subscribe-item' },
            React.createElement(Input, {
              id: 'newsletter-checkbox-' + index,
              type: 'checkbox',
              value: option.OptIn,
              onChange: function onChange(e) {
                return _this3.onClickCheckbox({ e: e, option: option });
              }
            }),
            React.createElement(
              'label',
              { htmlFor: 'newsletter-checkbox-' + index },
              translate({
                id: 'OPTIN.TYPE.' + option.Type.toUpperCase()
              }, intl)
            )
          );
        }),
        React.createElement(
          Button,
          {
            className: 'button primary',
            disabled: isLoading,
            onClick: function onClick() {
              return _this3.onSubmit({ optInOut: _this3.state.optInOut });
            } },
          translate({ id: 'ACTION.APPLY-SUBSCRIPTIONS' }, intl)
        )
      );
    }
  }]);

  return Subscriptions;
}(React.Component);

Subscriptions.propTypes = {
  /** Array of subscription options */
  optInOut: PropTypes.array,
  /** The submission function firing when submitting the form */
  onSubmit: PropTypes.func.isRequired
};

Subscriptions.defaultProps = {
  optInOut: []
};

export default injectIntl(Subscriptions);